import { index } from 'd3'
import { valuePropertyToUse } from '../value-property-to-use.js'

export function enrichLoadedData (chartOfAccounts, values) {
  if (!chartOfAccounts) return
  if (!values) return

  // Enrich the values with the chart of account
  const chartOfAccountsMap = index(chartOfAccounts, d => d.id)

  values.forEach(function (value) {
    const chartOfAccount = chartOfAccountsMap.get(value.accounting_chart_of_account_id)
    value.chartOfAccount = chartOfAccount

    // value.entity = {
    //   mongoId: dataEntity._id,
    //   xeroId: dataEntity.orgXeroId,
    //   baseCurrency: dataEntity.baseCurrency,
    //   name: dataEntity.name
    // }
  })

  // Enrich data with the period and balance values
  values.forEach(function (value) {
    const valueFxConversionProperty = value.chartOfAccount?.settings?.fxConversion

    value.forPeriodProperty = valuePropertyToUse('period', valueFxConversionProperty)
    value.forPeriod = value[value.forPeriodProperty]

    value.forBalanceProperty = valuePropertyToUse('balance', valueFxConversionProperty)
    value.forBalance = value[value.forBalanceProperty]

    if (!value.forPeriodProperty) {
      console.warn('no property? forPeriodProperty', value)
      console.log('valueFxConversionProperty', valueFxConversionProperty)
      console.log('valuePropertyToUse', valuePropertyToUse('period', valueFxConversionProperty))
    }
  })
}
